import React from 'react'
import styled from 'styled-components'

import { TagInfo } from './TagsInfo'

interface TagsListProps {
    onChange?: () => void
    batch?: any
    widget?: any
    height?: any
    event?: any
    title?: any
}

export function TagsList({ onChange, batch, widget, height, event = [], title = 'Tags List' }: TagsListProps) {
    if (!batch) return <div> 'loading...' </div>
    console.log(height)

    return (
        <DivMain height={height + 100}>
            <div className="container-tags">
                {batch.map((event, i) => {
                    return (
                        <TagInfo
                            key={event.device_tag}
                            device_tag={event.device_tag}
                            status={event.status}
                            line={event.line}
                            utility={event.utility}
                            measurement={event.measurement}
                        />
                    )
                })}
            </div>
        </DivMain>
    )
}

const DivMain = styled.div`
    margin:5px;
    height:100%;
    overflow: auto;

    .container-tags{
        /* height:${props => props.height + 'px'} */
    }


`
